import type { ResourceCategory } from '../types/resources'

export const resourceCategories: ResourceCategory[] = [
  {
    id: 'bedrijfsprofielen',
    title: 'Bedrijfsprofielen & gidsen',
    intro:
      'Op deze platformen staan de basisgegevens van LeonDesign: adres in Geleen, telefoonnummer, e-mailadres en de categorie lederwaren. Handig wanneer u de gegevens los van deze site wilt controleren.',
    items: [
      {
        name: 'AddonBiz',
        anchor: 'bedrijfsprofiel van LeonDesign op AddonBiz',
        description:
          'Profiel met het volledige vestigingsadres Spaans Neerbeek 25 in Geleen en de bedrijfscategorie.',
        href: 'https://www.addonbiz.com/listing/spaans-neerbeek-25-geleen-limburg-6164-ch-leondesign/',
      },
      {
        name: 'Cybo',
        anchor: 'LeonDesign in de bedrijvengids van Cybo',
        description:
          'Internationale bedrijvengids met de contactgegevens en de plaatsbepaling van de onderneming in Limburg.',
        href: 'https://www.cybo.com/NL-biz/leon-design-nl',
      },
      {
        name: 'Brownbook',
        anchor: 'Brownbook-vermelding voor lederwaren uit Geleen',
        description:
          'Open bedrijvengids waarin de winkelcategorie en de contactmogelijkheden zijn opgenomen.',
        href: 'https://www.brownbook.net/business/55398129/leondesign',
      },
      {
        name: 'Tupalo',
        anchor: 'Tupalo-profiel van LeonDesign in Geleen',
        description:
          'Lokale gids waarin bedrijven per stad en per branche worden weergegeven.',
        href: 'https://www.tupalo.net/en/geleen/leondesign',
      },
      {
        name: 'Trueen',
        anchor: 'Trueen-bedrijfspagina van LeonDesign',
        description: 'Bedrijfsprofiel met korte omschrijving en verwijzing naar de webshop.',
        href: 'https://trueen.com/business/listing/leondesign/783344',
      },
      {
        name: 'Youbiz',
        anchor: 'Youbiz-vermelding van de lederwarenspecialist',
        description: 'Beknopt profiel met bedrijfsnaam, branche en contactgegevens.',
        href: 'https://www.youbiz.com/listing/leondesign.html',
      },
      {
        name: 'BizRatings',
        anchor: 'BizRatings-profielpagina van LeonDesign',
        description: 'Bedrijvenoverzicht met de NAW-gegevens van de onderneming.',
        href: 'https://www.bizratings.com/profilepage.aspx?params=RC-120582-LeonDesign',
      },
      {
        name: 'Directory9',
        anchor: 'Directory9-vermelding voor lederwaren',
        description: 'Algemene webgids met een korte omschrijving van het assortiment.',
        href: 'https://directory9.net/listing/leondesign.html',
      },
      {
        name: 'LinkCentre',
        anchor: 'LinkCentre-profiel van de lederwarenwebshop',
        description: 'Webgids met een verwijzing naar de hoofdwebsite van LeonDesign.',
        href: 'https://www.linkcentre.com/profile/leondesign/',
      },
    ],
  },
  {
    id: 'lokaal',
    title: 'Nederlandse vermeldingen & citaties',
    intro:
      'Nederlandstalige platformen waarop LeonDesign als bedrijf uit Sittard-Geleen te vinden is. Deze vermeldingen zijn vooral bruikbaar voor bezoekers die specifiek in de regio Limburg zoeken.',
    items: [
      {
        name: 'Marktnet',
        anchor: 'LeonDesign op Marktnet',
        description:
          'Nederlandse dienstengids waarin de onderneming onder overige diensten is opgenomen.',
        href: 'https://www.marktnet.nl/diensten/overige-diensten/leondesign-96549552.htm',
      },
      {
        name: 'Nearfinder Nederland',
        anchor: 'Nearfinder-pagina voor winkelen in Geleen',
        description: 'Regionale gids met LeonDesign in de categorie winkelen binnen Limburg.',
        href: 'https://nearfindernl.com/nl/business/li/geleen/categorie_winkelen/leondesign_1611172+5.html',
      },
      {
        name: 'EnrollBusiness Nederland',
        anchor: 'EnrollBusiness-profiel met postcode 6164 CH',
        description: 'Bedrijfsprofiel met adres, postcode en contactgegevens in Geleen.',
        href: 'https://nl.enrollbusiness.com/BusinessProfile/7917472/LeonDesign-6164-CH-Geleen/Home',
      },
      {
        name: 'Oozo',
        anchor: 'Oozo-bedrijvenoverzicht Geleen-Zuid',
        description:
          'Nederlands bedrijvenregister dat ondernemingen per wijk en gemeente weergeeft.',
        href: 'https://www.oozo.nl/bedrijven/sittard-geleen/geleen/geleen-zuid/591634/goederenhandel-leon',
      },
      {
        name: 'Acompio',
        anchor: 'Acompio-bedrijfspagina van LeonDesign',
        description: 'Nederlandstalige bedrijvengids met branche-indeling en contactblok.',
        href: 'https://www.acompio.nl/LeonDesign-47790663.html',
      },
      {
        name: 'Infobel',
        anchor: 'Infobel-vermelding met telefoonnummer',
        description:
          'Telefoon- en bedrijvengids met de zakelijke gegevens van de onderneming in Geleen.',
        href: 'https://www.infobel.com/nl/netherlands/leondesign/geleen/NL100124156-0611087851/businessdetails.aspx',
      },
      {
        name: 'Locanto Sittard-Geleen',
        anchor: 'Locanto-advertentie in de categorie shopping & retail',
        description: 'Regionaal advertentieplatform met een korte introductie van de winkel.',
        href: 'https://www.locanto.nl/sittard-geleen/ID_9240683141/LeonDesign-Shopping-retail.html',
      },
      {
        name: 'Nextdoor',
        anchor: 'Nextdoor-buurtpagina van LeonDesign Geleen',
        description: 'Buurtplatform waarop lokale ondernemers zich aan omwonenden voorstellen.',
        href: 'https://nextdoor.nl/page/leondesign-geleen-li',
      },
      {
        name: 'Europages',
        anchor: 'Europages-profiel voor zakelijke afnemers',
        description:
          'Europese B2B-gids, relevant voor horeca- en bedrijfsklanten die leveranciers zoeken.',
        href: 'https://www.europages.nl/nl/company/leondesign-22408939',
      },
      {
        name: 'WhatsYourHours',
        anchor: 'openingstijden van LeonDesign',
        description: 'Vermelding gericht op bereikbaarheid en openingstijden van het bedrijf.',
        href: 'https://www.whatsyourhours.com/netherlands/geleen/business-services/leondesign',
      },
    ],
  },
  {
    id: 'kaarten',
    title: 'Kaarten & locatiebronnen',
    intro:
      'Wilt u zien waar Spaans Neerbeek 25 in Geleen precies ligt? Via onderstaande kaartdiensten is de locatie terug te vinden.',
    items: [
      {
        name: 'ScribbleMaps',
        anchor: 'kaartweergave van LeonDesign',
        description: 'Interactieve kaart met de vestigingslocatie in Geleen.',
        href: 'https://www.scribblemaps.com/maps/view/LeonDesign/leondesignnl',
      },
      {
        name: 'ZeeMaps',
        anchor: 'ZeeMaps-locatiekaart',
        description: 'Kaartdienst met een markering op het adres in Limburg.',
        href: 'https://www.zeemaps.com/map/opdue?group=7139110',
      },
      {
        name: 'Place123',
        anchor: 'Place123-locatiepagina',
        description: 'Plaatsgebonden vermelding met adresgegevens en oriëntatie in de omgeving.',
        href: 'http://www.place123.net/place/leon-design-geleen-netherlands',
      },
      {
        name: 'AskMap',
        anchor: 'AskMap-locatie van LeonDesign',
        description: 'Kaartgerichte gids met het volledige vestigingsadres.',
        href: 'http://www.askmap.net/location/7888633/netherlands/leondesign',
      },
      {
        name: 'Foursquare for Business',
        anchor: 'Foursquare-locatieprofiel',
        description: 'Locatieplatform dat door diverse kaart- en navigatie-apps wordt gebruikt.',
        href: 'https://business.foursquare.com/places/6a7828919fa5a45eaecd74bc/',
      },
      {
        name: 'Wanderboat',
        anchor: 'Wanderboat-pagina over LeonDesign',
        description: 'Plaatsgebonden ontdekkingsplatform met een korte bedrijfsomschrijving.',
        href: 'https://wanderboat.ai/posts/leondesign/TcRccxNbQTGLDq-TcIGhQA',
      },
    ],
  },
  {
    id: 'media',
    title: 'Social, publicaties & media',
    intro:
      'Kanalen waarop LeonDesign beeldmateriaal, publicaties en updates over lederwaren deelt. Nuttig als u eerst een indruk van het assortiment wilt krijgen.',
    items: [
      {
        name: 'Issuu',
        anchor: 'digitale publicaties van LeonDesign',
        description: 'Online publicatieplatform voor bladerbare documenten en presentaties.',
        href: 'https://issuu.com/leondesignnl',
      },
      {
        name: 'Medium',
        anchor: 'artikel van LeonDesign op Medium',
        description: 'Achtergrondartikel over de webshop en het aanbod in leren accessoires.',
        href: 'https://medium.com/@leondesignnl/leondesign-b92d776e198d?postPublishedType=initial',
      },
      {
        name: 'Speaker Deck',
        anchor: 'presentaties van LeonDesign',
        description: 'Platform voor het delen van presentaties over producten en toepassingen.',
        href: 'https://speakerdeck.com/leondesignnl',
      },
      {
        name: 'Wakelet',
        anchor: 'verzamelde LeonDesign-content op Wakelet',
        description: 'Collecties met links en beeldmateriaal rondom lederwaren.',
        href: 'https://wakelet.com/@LeonDesign7975',
      },
      {
        name: 'Penzu',
        anchor: 'publieke notitie over LeonDesign',
        description: 'Kort geschreven stuk over de onderneming en haar assortiment.',
        href: 'https://penzu.com/public/9e55b6613359e34c',
      },
      {
        name: '4mark',
        anchor: '4mark-bijdrage over de lederwarenwebshop',
        description: 'Publicatieplatform met een korte tekst over LeonDesign.',
        href: 'http://www.4mark.net/story/16474469/leondesign',
      },
      {
        name: 'Disqus',
        anchor: 'Disqus-profiel van LeonDesign',
        description: 'Publiek profiel dat gebruikt wordt voor reacties en discussies online.',
        href: 'https://disqus.com/by/leon_design/about/',
      },
      {
        name: 'Zumvu',
        anchor: 'Zumvu-profielpagina',
        description: 'Marketingplatform met een overzichtspagina van de onderneming.',
        href: 'https://www.zumvu.com/leondesignnl/',
      },
      {
        name: 'Solo.to',
        anchor: 'linkpagina van LeonDesign',
        description: 'Verzamelpagina met de belangrijkste kanalen op één plek.',
        href: 'https://solo.to/leondesignnl',
      },
      {
        name: 'Shorby',
        anchor: 'Shorby-linkoverzicht',
        description: 'Tweede verzamelpagina met doorverwijzingen naar webshop en sociale kanalen.',
        href: 'https://shor.by/leondesignnl',
      },
      {
        name: 'ArtJobs',
        anchor: 'ArtJobs-profiel rond ontwerp en vormgeving',
        description: 'Creatief platform waarop het ontwerpgerichte karakter van het merk terugkomt.',
        href: 'https://www.artjobs.com/users/leondesignnl',
      },
      {
        name: 'Icecream.me',
        anchor: 'Icecream-profielpagina',
        description: 'Klein profielplatform met een verwijzing naar de website.',
        href: 'http://icecream.me/a6bcd6d2bd9f3882c95b84b561a6ed0e',
      },
    ],
  },
  {
    id: 'zakelijk',
    title: 'Zakelijke & professionele platforms',
    intro:
      'Voor horeca-ondernemers, taxibedrijven, kappers en andere zakelijke afnemers zijn vooral de B2B-platformen en afsprakenpagina’s hieronder relevant.',
    items: [
      {
        name: 'EC21',
        anchor: 'B2B-profiel van LeonDesign op EC21',
        description: 'Internationale handelsplatform-pagina gericht op zakelijke afnemers.',
        href: 'https://leondesignnl.en.ec21.com/',
      },
      {
        name: 'DealerBaba',
        anchor: 'leveranciersprofiel van LeonDesign',
        description: 'B2B-gids met het bedrijf in de categorie leveranciers.',
        href: 'https://www.dealerbaba.com/suppliers/leondesign-msoaa0o2',
      },
      {
        name: 'Trepup',
        anchor: 'Trepup-winkelprofiel',
        description: 'Zakelijk netwerk met een productgerichte bedrijfspagina.',
        href: 'https://www.trepup.com/store/leondesignn/profile',
      },
      {
        name: 'Dibiz',
        anchor: 'digitaal visitekaartje van LeonDesign',
        description: 'Digitale bedrijfskaart met contactgegevens in één overzicht.',
        href: 'https://www.dibiz.com/leondesignnl',
      },
      {
        name: 'Startupxplore',
        anchor: 'ondernemingsprofiel op Startupxplore',
        description: 'Platform voor ondernemingen met een korte bedrijfsomschrijving.',
        href: 'https://startupxplore.com/en/startups/leondesign-1',
      },
      {
        name: 'iFormative',
        anchor: 'productvermelding van LeonDesign',
        description: 'Productgerichte gids met een omschrijving van het aanbod.',
        href: 'https://www.iformative.com/product/leondesign-p3107771.html',
      },
      {
        name: 'Reservio',
        anchor: 'afsprakenpagina via Reservio',
        description: 'Boekingsomgeving waarmee een afspraak of contactmoment kan worden ingepland.',
        href: 'https://leondesign.reservio.com/',
      },
      {
        name: 'Setmore',
        anchor: 'Setmore-agenda van LeonDesign',
        description: 'Alternatieve boekingspagina voor het inplannen van een afspraak.',
        href: 'https://leondesign.setmore.com/',
      },
      {
        name: 'SimplyBook',
        anchor: 'SimplyBook-boekingsomgeving',
        description: 'Derde afsprakenmodule voor zakelijke contactmomenten.',
        href: 'https://leondesignnl.simplybook.it/v2/',
      },
      {
        name: 'Blinx',
        anchor: 'Blinx-bedrijfspagina',
        description: 'Zakelijk platform met een beknopt profiel van de onderneming.',
        href: 'https://www.blinx.biz/leondesign',
      },
      {
        name: 'LetsKnowIt',
        anchor: 'LetsKnowIt-profiel van LeonDesign',
        description: 'Netwerkplatform met bedrijfsgegevens en een verwijzing naar de webshop.',
        href: 'https://letsknowit.com/leondesign178544',
      },
      {
        name: 'Experiment',
        anchor: 'gebruikersprofiel op Experiment',
        description: 'Publiek profiel met een korte introductie van het bedrijf.',
        href: 'https://experiment.com/users/leondesignnl',
      },
    ],
  },
  {
    id: 'overig',
    title: 'Overige relevante bronnen',
    intro:
      'Aanvullende vermeldingen die het beeld compleet maken. Ze bevatten grotendeels dezelfde kerngegevens, maar kunnen nuttig zijn bij het verifiëren van de onderneming.',
    items: [
      {
        name: 'SupplyAutonomy',
        anchor: 'SupplyAutonomy-vermelding van LeonDesign',
        description: 'Overzichtspagina met de belangrijkste bedrijfsgegevens.',
        href: 'https://supplyautonomy.com/leondesign1.nl',
      },
      {
        name: 'BestDealFinder',
        anchor: 'BestDealFinder-vermelding voor winkelen in Geleen',
        description: 'Consumentgerichte gids met de winkelcategorie van LeonDesign.',
        href: 'http://www.bestdealfinder.com/netherlands/geleen/shopping/leondesign',
      },
      {
        name: 'WeGotAGuy',
        anchor: 'WeGotAGuy-pagina voor Limburg',
        description: 'Lokale gids die aanbieders per provincie en plaats ordent.',
        href: 'https://www.wegotaguy.net/shopping/geleen/limburg/leondesign',
      },
      {
        name: 'YPLocal',
        anchor: 'YPLocal-vermelding speciaalzaken',
        description: 'Gids voor speciaalzaken, met LeonDesign onder de winkels in Geleen.',
        href: 'https://www.yplocal.com/geleen/shopping-specialty-stores/leondesign',
      },
      {
        name: 'Where2Go',
        anchor: 'Where2Go-bedrijfsvermelding',
        description: 'Zoekgids met de contactgegevens van de onderneming.',
        href: 'https://where2go.com/binn/b_search.w2g?function=detail&type=quick&listing_no=2217350&_UserReference=7F00000146544A622797A3DDF3E26A7AB5C8',
      },
      {
        name: 'BizCoupon Directory',
        anchor: 'BizCoupon-vermelding Geleen',
        description: 'Gids voor zakelijke dienstverlening in de regio Sittard-Geleen.',
        href: 'https://www.bizcoupon.directory/netherlands/geleen/business-services/leondesign',
      },
      {
        name: 'BestInCom',
        anchor: 'BestInCom-profiel van LeonDesign',
        description: 'Bedrijvenoverzicht met de vestigingsplaats Geleen.',
        href: 'https://www.bestincom.com/geleen/marketing-providers/leondesign',
      },
    ],
  },
]

export const resourceCount = resourceCategories.reduce((total, c) => total + c.items.length, 0)
